import React, { useState, useRef } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'components/graphql'
import gql from 'graphql-tag'
import { ConfirmModal } from 'components/Modal'
import ChangeAPKVersion from './ChangeAPKVersion'
import getCashRegister from '../../gql/getCashRegister'
import Button from 'components/Button'
import Divider from 'components/Divider'

import { Text, Select } from 'components/forms'

const resyncMutation = gql`
	mutation allowCredentials($hardwareId: ID!) {
	  resyncDevice(hardwareId: $hardwareId) {
	    hardwareId
	  }
	}
`

const unpairMutation = gql`
mutation unpairDevice ($cashRegisterId: ID!) {
  cashAssist {
    unpairDevice(cashRegisterId: $cashRegisterId) {
      id
      name
      status
    }
  }
}
`

const pairMutation = gql`
mutation pairDevice($cashRegisterId: ID!, $hardwareId: ID!) {
  cashAssist {
  	pairDevice(cashRegisterId: $cashRegisterId, hardwareId: $hardwareId){
			id
			name
			hardwareId
  	}
	}
}`

const listDevicesQuery = gql`
query listDevices($filter: AndroidDevicesFilter, $params: ListQueryArgs) {
  listDevices(filter: $filter, params: $params) {
    cursors {
			after
      hasNext
    }
  	items {
			hardwareId
			model
    }
  }
}
`

const Android = ({ cashRegister, deviceIdentity, deviceType, id, shopId }) => {
	const hardwareId = deviceIdentity ? deviceIdentity.hardwareId : ''
	const [isPaired, setPair] = useState(!!hardwareId)
	const [hardwareValue, setHardwareValue] = useState(hardwareId)
	const queryRef = useRef({})
	const [t] = useTranslation()
	const [handleResync] = useMutation(resyncMutation, {
		variables: { hardwareId }
	})
	const [handleUnpair] = useMutation(unpairMutation, {
		variables: { cashRegisterId: id }
	})
	const [handlePair] = useMutation(pairMutation)

	const unpairClick = () => ConfirmModal({
		text: t('options_section.strings.unpair_device'),
		label: t('options_section.strings.unpair')
	}).then(async () => {
		await handleUnpair({
			refetchQueries: [{
				query: getCashRegister,
				variables: { id }
			}]
		})
		if(queryRef.current) {
			queryRef.current.refetch()
		}
		setPair(false)
		setHardwareValue('')
	})

	const pairClick = async () => {
		if(!hardwareValue) {
			return null
		}
		await handlePair({
			variables: {
				cashRegisterId: id,
				hardwareId: hardwareValue
			},
			refetchQueries: [{
				query: getCashRegister,
				variables: { id }
			}]
		})
		if(queryRef.current) {
			queryRef.current.refetch()
		}
		setPair(true)
		setHardwareValue(hardwareValue)
	}

	const onHardwareChange = option => {
		setHardwareValue(option.hardwareId || option.value)
	}

	return(
		<>
			<Row>
				<Col xs>
					<Select
						inline
						style={{ width: 300 }}
						disabled={isPaired}
						field='deviceType'
						label={t('options_section.strings.software')}
						options={[{
							label: 'SmartCheckout',
							value: 'SMART_CHECKOUT'
						}, {
							label: 'SelfCheckout',
							value: 'SELF_CHECKOUT'
						}, {
							label: 'MobileWaiter',
							value: 'MOBILE_WAITER'
						}, {
							label: 'SmartLabel',
							value: 'SMART_LABEL'
						}, {
							label: 'KDS',
							value: 'KDS'
						}]}
					/>
				</Col>
				<Col xs>
					<Select
						noForm
						inline
						simpleValue={false}
						isSearchable
						style={{ width: '300px' }}
						label={t('options_section.strings.serial_no')}
						valueField='hardwareId'
						labelField='hardwareId'
						isDisabled={isPaired}
						value={{ hardwareId: hardwareValue }}
						onChange={onHardwareChange}
						remoteOptions={{
							ref: queryRef,
							query: listDevicesQuery,
							fetchPolicy: 'cache-and-network',
							variables: { filter: { isPaired: false } },
							modifyOptions: options => options.filter(item => item.model !== 'SUNMI_CLOUD_PRINTER')
						}}
					/>
				</Col>
			</Row>
			<Divider/>
			{isPaired && <>
				<ChangeAPKVersion
					cashRegister={cashRegister}
					hardwareId={hardwareValue}
					isPaired={isPaired}
					id={id}
					shopId={shopId}
				/>
				<Text readOnly noForm value={cashRegister?.device?.appManagerVersion} label={t('options_section.strings.version_app_manager')}/>
				<Text readOnly noForm value={cashRegister?.parameters?.localIPAdress} label={t('options_section.strings.localIPAdress')}/>
				<Divider/>
			</>}
			<div>
				<Button inline text={t('options_section.strings.allow_resync')} onClick={handleResync} status={isPaired ? 'primary' : 'inactive'} />
				{isPaired
					? <Button inline text={t('options_section.strings.unpair')} onClick={unpairClick} style={{ background: '#c13c44' }} />
					: <Button inline text={t('options_section.strings.pair')} onClick={pairClick} />
				}
			</div>
		</>
	)
}

export default Android
